/**
 * iDiamonds — extinderea garanției pentru produsele din magazin.
 *
 * 1. O singură bifă, ca la gravură. Fără câmp obligatoriu, deci nu blochează
 *    niciodată adăugarea în coș.
 * 2. La submit-ul formularului de produs (capture, ca în custom-engraving.js)
 *    reține dacă bifa era pusă, varianta părinte și cantitatea.
 * 3. După ce produsul intră în coș (eveniment `product-ajax:added`), adaugă
 *    produsul-taxă ca linie separată, legată prin `_pentru_varianta`.
 *
 * Bifa nu are atribut `name`, exact ca la gravură: formularul de produs se
 * serializează cu `new FormData(form)`, iar un câmp fără nume nu ajunge
 * niciodată proprietate pe linia produsului părinte.
 *
 * Fără localStorage: în preview/theme editor storefront-ul rulează în iframe
 * unde localStorage poate fi blocat.
 */
class WarrantyExtension extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.variantId = this.dataset.variantId;
    this.productTitle = this.dataset.productTitle;
    this.checkbox = this.querySelector('.warranty-extension__checkbox');

    if (!this.form || !this.variantId || !this.checkbox) return;

    this.pending = null;

    this._onSubmit = this._onSubmit.bind(this);
    this._onProductAdded = this._onProductAdded.bind(this);

    this.form.addEventListener('submit', this._onSubmit, true);
    document.addEventListener('product-ajax:added', this._onProductAdded);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this._onSubmit, true);
    document.removeEventListener('product-ajax:added', this._onProductAdded);
  }

  _parentVariantId() {
    const idInput = this.form.querySelector('[name="id"]');
    return idInput ? String(idInput.value) : '';
  }

  _quantity() {
    const qtyInput = this.form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  _onSubmit() {
    // Se resetează la fiecare încercare de adăugare în coș.
    this.pending = null;
    if (!this.checkbox.checked) return;

    const parentVariantId = this._parentVariantId();
    if (!parentVariantId) return;

    this.pending = { parentVariantId, quantity: this._quantity() };
  }

  _onProductAdded() {
    if (!this.pending) return;
    const { parentVariantId, quantity } = this.pending;
    this.pending = null;
    this._addWarranty(parentVariantId, quantity);
  }

  async _addWarranty(parentVariantId, quantity) {
    try {
      await window.iDiamonds.linkedItems.add({
        variantId: this.variantId,
        quantity,
        properties: {
          'Extra garanție': this.productTitle,
          _pentru_varianta: parentVariantId,
        },
      });
      this.checkbox.checked = false;
    } catch (error) {
      console.error('Garanție — adăugare eșuată:', error);
    }
  }
}

if (!customElements.get('warranty-extension')) {
  customElements.define('warranty-extension', WarrantyExtension);
}
